import { ChangeDetectorRef, Component, DoCheck, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChildren, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertController, IonItemSliding, IonList, ModalController, NavController, Platform } from '@ionic/angular';
import { collapseAnimation, collapseOnLeaveAnimation, expandOnEnterAnimation, slideOutRightAnimation } from 'angular-animations';
import * as confetti from 'canvas-confetti';
import mixpanel from 'mixpanel-browser';
import * as moment from 'moment';
import { AlertActionCompleteComponent } from '../alert-action-complete/alert-action-complete.component';
import { AlertGiveFeedbackCommitmentComponent } from '../alert-give-feedback-commitment/alert-give-feedback-commitment.component';
import { AlertSupportComponent } from '../alert-support/alert-support.component';
import { AlertUnlockLevelComponent } from '../alert-unlock-level/alert-unlock-level.component';
import { AlertWebactionCalendarComponent } from '../alert-webaction-calendar/alert-webaction-calendar.component';
import { AppState } from '../app.service';
import { CalendarService } from '../calendar.service';
import { Client } from '../client/client.model';
import { CompletedReviewModalComponent } from '../completed-review-modal/completed-review-modal.component';
import { FeedbackFormComponent } from '../components/commitments/feedback-form/feedback-form.component';
import { CordovaService } from '../cordova.service';
import { RoutineService } from '../daily-content-v2/routine.service';
import { DailyStepsService } from '../daily-steps/daily-steps.service';
import { FullScreenAudioComponent } from '../full-screen-audio/full-screen-audio.component';
import { FullScreenVideoComponent } from '../full-screen-video/full-screen-video.component';
import { HabitListItem } from '../habit-list-modal/habit-list-modal.model';
import { Habit } from '../habit/habit.model';
import { HabitService } from '../habit/habit.service';
import { I18n } from '../i18n.service';
import { InoutScreen } from '../inout-screen/inout-screen.model';
import { FullScreenDocumentComponent } from '../my-library/full-screen-document.component';
import { HomeUiService } from '../new-design/home-ui.service';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { Path } from '../path/path-v2.model';
import { RatingAlertBoxComponent } from '../rating-alert-box/rating-alert-box.component';
import { ReoptHabitLevelModalComponent } from '../reopt-habit-level-modal/reopt-habit-level-modal.component';
import { RoutineInfo } from '../routine-v2/routine-info.model';
import { RoutineV2Service } from '../routine-v2/routine-v2.service';
import { NativeService } from '../services/native.service';
import { AnimationsService } from '../shared/animations.service';
import { SpinnerService } from '../spinner.service';
import { ToasterService } from '../toaster.service';
import { User } from '../user/user.model';
import { MyCommitmentsService } from './my-commitments.service';
import { DailyStepsContentWebModalV2Component } from '../new-design/daily-steps-content-web-modal-v2/daily-steps-content-web-modal-v2.component';
import { KyperDataApiService } from '../services/kyper-data-api.service';
import { PracticeBotModalComponent } from '../new-design/practice-bot-modal/practice-bot-modal.component';


export interface CalendarParams {
  title: String,
  startDate: Date
  endDate: Date,
  eventLocation: String,
  notes: String,
  endEventTime: any,
  frequency: string
}

export interface unSelectedLevelsRoutine {
  level,
  habits,
  path_id,
  schedule_day,
  habitGroupId
}
@Component({
  selector: 'first90-my-commitments',
  templateUrl: './my-commitments.component.html',
  styleUrls: ['./my-commitments.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    slideOutRightAnimation({duration: 500}),
    collapseAnimation(),
    expandOnEnterAnimation({ duration: 250 }),
    collapseOnLeaveAnimation({ duration: 250 })
  ]
})
export class MyCommitmentsComponent implements OnInit, DoCheck {
  videoFormats = ['.mp4', '.mov', '.avi', '.avchd', '.f4v', '.mkv', '.wmv','youtube.com', 'webm', 'html5', 'HTML5', 'watch'];
  audioFormats = [".mp3"];
  isEditRoutineEnabled: boolean = false;
  client: Client;
  currentPath: Path;
  currentUser: User;
  habits;
  calendarParams: CalendarParams;
  habit: Habit
  currentDay: number
  routineList: any
  editRoutineList;
  isCheckedAll: boolean = false
  routineLevels: any
  isExpanded: boolean = false
  routineId: number
  scheduledDay: number
  actionList;
  currentRoutine: any
  isNextScreen: boolean = false
  makeHabit: boolean
  canvas: ElementRef
  levelId: any
  routine
  levelNumber: number
  routineDay: number
  isMobile: boolean
  showTab: boolean;
  showAction: boolean;
  currentTab: number;
  isTabChange = false;
  @Input() isHomeRoute: boolean;
  myHabitLabel: string
  myActionLabel: string
  isonboardingcompleted: any;
  makeActive: boolean = false;
  indexOfLevel: number
  selectedLevels = []
  hasNativeCalendar;
  inoutScreen: InoutScreen;
  screensIds = []
  screensEnabled = {}
  isUnSelectedLevelExpanded = [];
  unSelectedLevelClicked = [];
  isUncommitedRoutineClicked= [];
  uncommitedRoutine: boolean[] = [];;
  completedHabitsLevelList
  unlockedHabitGroup = [];
  options: [
    {
      label: 'Sliding Entrances',
      animations: ['slideOutRight']
    },
    {
      label: 'Other',
      animations: ['expandCollapse']    
    },
  ]
  animationState = false;
  web_todoLevelsList = [];
  web_todoLockedLevelsList = [];
  web_completedLevelsList=[]
  habitCommitmentIndex;
  actionCommitmentIndex;
  @ViewChildren('slidingItem') slidingItem: IonItemSliding[];
  @ViewChildren('HideactionList') HideactionList: IonList[];

  isTodoVisible: { [key: string]: boolean } = {};
  isTodoVisibleParent: { [key: string]: boolean } = {};
  hiddenRoutines: { [key: string]: boolean } = {};
  hiddenRoutinesParent: { [key: string]: boolean } = {};
  actionId: number
  checked: boolean = false
  expandCompleted = false
  expandNotCommitted = false
  scheduleDay: any
  showEditOptions = false
  showEditHabits = false
  @Output() onLogaRep: any = new EventEmitter<any>();
  completedActions: any
  isActionExpanded: boolean[] = [];
  isItemExpanded: boolean[] = [];
  isRoutineExpanded: boolean[] = [];
  ncAction: boolean[] = [];
  ncAction1: boolean[] = [];
  completedRoutine: boolean[] = [];
  isUncompletedRoutineClicked= [];
  routineClicked = []
  actionClicked = []
  completedActionClicked = []
  noncompletedActionClicked = []
  noncompletedActionClicked1 = []
  isUncommitedRoutineLevelClicked = [];
  uncommitedRoutineLevel: boolean[] = [];
  showActionCheckbox: boolean
  completedHabitsList: any
  unCommittedActionsList: any;
  unSelectedLevelsInfo : Array<unSelectedLevelsRoutine>;
  isDataLoaded = false;
  dailyStepsArray;
  /** Cache behind voicePracticeScreenIds(); null until the path data has been read. */
  /**
   * screen_content_ids that enable voice practice, cached because the chips ask per action on every
   * change-detection pass. Derived from dailyStepsArray, so it MUST be dropped whenever that is
   * reassigned — always go through setDailyStepsArray().
   */
  private voicePracticeIds: Set<string> | null = null;
  isInitiallyLoadedToDo = false;
  activeChapterIndex;
  activeStepIndex;
  constructor(
    private routineService: RoutineV2Service,
    private routeService: RoutineService,
    private dailyStepService: DailyStepsService,
    private cdRef: ChangeDetectorRef,
    private appState: AppState,
    private dialog: MatDialog,
    private calendarService: CalendarService,
    private modalController: ModalController,
    private homeService: HomeV5Service,
    private tostrService: ToasterService,
    private habitService: HabitService,
    public spinnerService: SpinnerService,
    private route: Router,
    private nav: NavController,
    private matDialog: MatDialog,
    private alertController: AlertController,
    private native: NativeService,
    private homeUIService: HomeUiService,
    private i18n: I18n,
    private cordovaService: CordovaService,
    private animationService: AnimationsService,
    private toasterService: ToasterService,
    private homev5Service: HomeV5Service,
    private platform: Platform,
    public commitService: MyCommitmentsService,
    private kyperApiService: KyperDataApiService
  ) {
      const w: any = window
      this.hasNativeCalendar = this.cordovaService.onCordova && w && w.plugins && w.plugins.calendar
      this.activeChapterIndex = this.appState.get('currentActiveChapter')
      this.activeStepIndex = this.appState.get('reviewingStepIndex')
      if (localStorage.getItem('currentDayAfterScreenView')) {
        this.scheduleDay = localStorage.getItem('currentDayAfterScreenView')
      } else {
        let currentScheduleDay = this.appState.get('currentScheduleDay')
        this.scheduleDay = currentScheduleDay > 1 ? currentScheduleDay - 1 : currentScheduleDay
      }
    if (this.appState.get('updateRoutineData')!=true && (this.appState.get('todoActions')?.length>0 || this.appState.get('todoActions')?.length>0 )) {
      this.fetchItemsInTodoList();
    }
    
  }
  fetchScreenTypeContent(screentype) {
    let dailyStepsArray = this.appState.get('DailyStepsData')
    return dailyStepsArray
  .map(step => step?.[screentype])
  .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
  .flatMap(s => Array.isArray(s) ? s : [s]);
  }
  editRoutineStatus() {
    const requestData = {
      'path_id': this.currentPath.id
    }

    if (requestData.path_id == 0) {
      return true;
    } else {
      this.closeOpenItems();
      this.kyperApiService.getHabitsList(requestData).subscribe(
        (response) => {
          this.routineList = this.homev5Service.removeDuplicates(response.habits, "habitGroupId");
      console.log("this.routineList...",response.habits, this.routineList);
      this.completedHabitsList = this.routineList.filter(item => item.isHabitGroupCompleted === true)
      this.completedHabitsLevelList=[]
      this.routineList?.forEach((routine) => {
        let completed_list = routine?.habits?.filter(item => item?.isHabitCompleted === true)
        if (completed_list?.length > 0) {
          this.completedHabitsLevelList.push(completed_list);
        }
      })
          this.appState.set('todoRoutines',this.removeDuplicates(response.habits, "habitGroupId"))
          // this.fetchItemsInTodoList();
          this.cdRef.detectChanges();
          this.editRoutineList = this.removeDuplicates(response.habits, "habitGroupId");
          this.routine = this.currentPath.filterStepsByContentType(this.dailyStepsArray,this.dailyStepsArray[this.activeChapterIndex]?.steps[this.activeStepIndex])
          console.log("this.routine", this.routine, this.editRoutineList);
          this.unSelectedLevelsInfo = [];
          let updated_routine = []
          // let routineInfo =this.fetchScreenTypeContent('routineInfo')
          // this.editRoutineList?.forEach((optRoutine) => {
          //   //  routineInfo?.forEach((routine) => {
          //   updated_routine =[]
          //   if (optRoutine?.habitGroupId && optRoutine?.isHabitOpted ==true) {
          //     if (optRoutine?.habits?.length != optRoutine?.selectedHabitIds?.length) {
          //       optRoutine?.habits?.forEach((level) => {
          //         let matchedLevel = optRoutine?.habits?.filter((optLevel) => optRoutine?.selectedHabitIds?.includes(optLevel.id))
          //         if (matchedLevel?.length == 0) {
          //           updated_routine = optRoutine?.habits
          //           let changedLevel = level
          //           changedLevel.enabled =false
          //           updated_routine.push(changedLevel)
          //           //updated_routine?.sort((a, b) => a?.level - b?.level);
          //           this.unSelectedLevelsInfo.push({ level: level, routine: updated_routine, path_id: optRoutine?.pathId,schedule_day: optRoutine?.schedule_day, habitGroupId: optRoutine?.habitGroupId })
          //           console.log("Unselected levels", this.unSelectedLevelsInfo,this.unSelectedLevelsInfo?.length);
          //         }
                
          //       })
          //       // this.unSelectedLevelsInfo = this.homev5Service.removeDuplicates(this.unSelectedLevelsInfo,'level')
          //     }
          //   }
          // // })
                   
          // })
          // this.getRoutines(this.currentPath.id);
          this.editRoutineList?.forEach((optRoutine) => {
            if (!optRoutine?.isHabitOpted) {
              this.unlockedHabitGroup.push(optRoutine)
            }
            if (!optRoutine?.habitGroupId || !optRoutine?.isHabitOpted ||optRoutine.selectedHabitIds?.length==0 ) {
              return;
            }

            const selectedIds = optRoutine.selectedHabitIds || [];
            // Find unselected habits
            const unSelectedHabits = optRoutine.habits?.filter(
              habit => !selectedIds.includes(habit.id)
            ) || [];
            let unlockingHabitStepDetails = this.currentPath.findChapterStepByScreenContentId(this.dailyStepsArray, optRoutine?.screenContentId)
            let routineDay = unlockingHabitStepDetails?.stepPosition
            unSelectedHabits.forEach(habit => {
              habit.enabled = false;
              this.unSelectedLevelsInfo.push({
                level: habit,
                habits: optRoutine,
                path_id: optRoutine.pathId,
                schedule_day: routineDay,
                habitGroupId: optRoutine.habitGroupId
              });
            });
          });
          console.log("unSelectedLevelsInfo",this.unSelectedLevelsInfo, this.unlockedHabitGroup)
          if(this.editRoutineList && this.editRoutineList.length>0 && this.currentTab ==0) {
            this.isEditRoutineEnabled =true;
          }
        },
        (error) => {
          console.log('Error for routines ', error)
          this.isDataLoaded=true
          this.tostrService.error(this.i18n.t('No record found'))
        })
    }
  }
  removeDuplicates(originalArray, prop) {
    var tempArray = [];

    tempArray = originalArray.filter(function (el) {
      return el.habitGroupId,
        el.isHabitOpted;
    });
    try{
      for (let i = 0; i < originalArray.length; i++) {
        for (let j = 0; j < tempArray.length; j++) {
          if ((tempArray[j].habitGroupId == originalArray[i].habitGroupId) && !originalArray[i].isHabitOpted) {
            originalArray.splice(i, 1);
          }
        }
      }
      originalArray = this.newremoveDuplicates(originalArray, prop)
      return originalArray;
    }catch (o_O){
      return tempArray;
    }

  }
  newremoveDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }
    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }
  ngOnInit() {
    this.setDailyStepsArray(this.appState.get("DailyStepsData"));
    this.init();
    this.commitService.setLoader(true)
    this.appState.set("isCommitmentsViewed", true)
    this.getActions(this.currentPath.id)
    this.editRoutineStatus();
    this.setActionsList();
    let levelSaveData = this.appState.get('levelSaveData')
    if (levelSaveData) {
      localStorage.setItem(
        `Toggle:Day:${levelSaveData.currentDay}:LevelNumber:${levelSaveData.levelId}:true`,
        'true'
      )
      this.appState.set('showUpdatedScreens', undefined)
      this.appState.set('levelSaveData', undefined)
    }

  }
  init() {
    this.myHabitLabel = this.i18n.t('MY HABITS')
    this.myActionLabel = this.i18n.t('MY MICRO-ACTIONS')
    this.client = this.appState.get('currentClient');
    this.currentPath = this.appState.get("currentPath");
    this.currentDay = this.appState.get('currentScheduleDay')
    this.currentUser = this.appState.get("currentUser");
    this.scheduledDay = this.appState.get("scheduleDayForCurrentStep")
    this.levelNumber = this.appState.get('levelId')
    this.isMobile = this.appState.get('isMobile')
    this.appState.set('page', 1)
    // this.getRoutines(this.currentUser?.id, this.currentPath.id);
  
  }

  ngDoCheck() {
     if (this.appState.get('scheduledHabitId') && this.appState.get('isEventRescheduled')) {
      this.appState.set('scheduledHabitId', null)
      this.appState.set('isEventRescheduled', null)
      //this.getRoutines(this.currentUser?.id, this.currentPath.id);
      this.cdRef.detectChanges()
    }
  }
  goToQuestion() {
    var supportDialog = this.matDialog.open(AlertSupportComponent);
    supportDialog.afterClosed().subscribe()
  }
  changeTab(evn) {
    this.currentTab = evn.index;
    let tabValue = this.currentTab == 0 ? this.myHabitLabel : this.myActionLabel
    mixpanel.track('Commitments-Tab Selected', {tab: tabValue})
    this.isTabChange = true;
    localStorage.setItem('commitmentTab', this.currentTab.toString());
    this.showAction = true;
    if (this.currentTab != 0) {
      this.isEditRoutineEnabled = false;
    } else {
      this.routineList.forEach(element => {
        if (element.pathId === this.currentPath.id) {
          this.currentTab = 0;
          this.isEditRoutineEnabled = true;
        }
      });
      this.editRoutineStatus();
    }
  }

  textToSpeech() {
    this.native.textToSpeech();
  }

  showAnimation() {
    const myConfetti = confetti.create(this.canvas, {
      resize: true // will fit all screen sizes
    });
    myConfetti();

  }

  findHabitbyId(collection: any, id: any): any {
    return collection.find(
      item => item.id === id
    )
  }

  fetchItemsInTodoList() {
   let routine= this.appState.get('todoRoutines')
    let action= this.appState.get('todoActions')
     this.routineList = this.homev5Service.removeDuplicates(routine, "habitGroupId");
      console.log("this.routineList...",routine, this.routineList);
      this.completedHabitsList = this.routineList.filter(item => item.isHabitGroupCompleted === true)
      this.completedHabitsLevelList=[]
      this.routineList?.forEach((routine) => {
        let completed_list = routine?.habits?.filter(item => item?.isHabitCompleted === true)
        if (completed_list?.length > 0) {
          this.completedHabitsLevelList.push(completed_list);
        }
      })
      console.log('|| completedHabitsLevelList?.length<1', this.completedHabitsLevelList)
    this.actionList = action?.filter((action)=>action.id && !action.userActionCompletion && action.userActionScheduledLater);
    this.isInitiallyLoadedToDo = true;
  }
  getRoutines(pathId: number,functionName?, params?) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getHabitsList(requestData).subscribe((response) => {
      this.isItemExpanded.push(false);
      this.showTab = true     
      // if (!this.isInitiallyLoadedToDo ||this.appState.get('updateRoutineData')) {
        this.routineList = this.homev5Service.removeDuplicates(response.habits, "habitGroupId");
        console.log("this.routineList... entered inside routines", response.habits, this.routineList);
        this.completedHabitsList = this.routineList.filter(item => item.isHabitGroupCompleted === true)
        this.completedHabitsLevelList = []
        this.routineList?.forEach((routine) => {
          let completed_list = routine?.habits?.filter(item => item?.isHabitCompleted === true)
          if (completed_list?.length > 0) {
            this.completedHabitsLevelList.push(completed_list);
          }
        })
        console.log('|| completedHabitsLevelList?.length<1', this.completedHabitsLevelList)
        this.appState.set('updateRoutineData', undefined)
      // }
      this.isInitiallyLoadedToDo = false;
     
      this.setTab();
      this.appState.set('todoRoutines',this.homev5Service.removeDuplicates(response.habits, "habitGroupId"))
      this.isDataLoaded = true;
      this.performActionsAfterFetch(functionName, params)
      this.cdRef.detectChanges();
    }, (error) => {
      this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."));
      this.isDataLoaded =true
      console.log('error :', error);
    })
  }

  getActions( pathId: number,functionName?, params?) {
    const requestData = {
      'path_id': pathId
    }
    this.kyperApiService.getActionsList(requestData).subscribe((response) => {
      this.isItemExpanded.push(false);
      this.showTab = true     
      if (!this.isInitiallyLoadedToDo ||  this.actionList?.length==0 ) {
        this.actionList = response.actions?.filter((action)=>action.id && !action.userActionCompletion && action.userActionScheduledLater) ;
      }
      this.unCommittedActionsList = response.actions.filter(item => !item.id || (!item.userActionCompletion && !item.userActionScheduledLater));
      this.completedActions = response.actions.filter(item => item.userActionCompletion);
      this.isInitiallyLoadedToDo = false;
      this.setTab();
      this.appState.set('todoActions', response.actions)
      this.isDataLoaded = true;
      this.performActionsAfterFetch(functionName, params)
      this.cdRef.detectChanges();
    }, (error) => {
      this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."));
      this.isDataLoaded =true
      console.log('error :', error);
    })
  }

  performActionsAfterFetch(name,params) {
    switch (name) {
      case 'deleteAction': this.routineService.deleteActionFromPath(params, this.habits);
      case 'inithabitModal': this.setActionsList();
        case 'habitConfirm_condensed': this.setActionsList();
    }
  }
  openDocument(post) {
    console.log('post before...', post)
        let postsDocs = this.appState.get("casualDocuments")
     let posts;
    // posts= post?.document
     postsDocs?.forEach((doc)=>{
      if(doc.id ==post?.tool?.id){
        posts =doc;
      }
    })
    let doc = this.appState.get('singleDocument');
    if(posts?.id == doc?.id) {
      posts =this.appState.get('singleDocument')
    }
    
    this.appState.set('singleDocument', posts)
    this.appState.set('journalPost', undefined)
    console.log("post",posts);
    if (posts.isrecommended && posts.isrecommended === true) {
      this.appState.set('isCasualDocument', true)
    }
  
    this.appState.set('journalPathName', this.currentPath.name)
    let stepNumber = this.currentPath.findChapterStepByScreenContentId(this.appState.get('DailyStepsData'), post.screenId,true)?.stepPosition;
    this.appState.set('journalStepNumber', stepNumber)
    const url = posts.link;
    if (this.audioFormats.some(el => url.includes(el))) {
      console.log('Audio File');
      mixpanel.track('Commitments-Open Documents', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Audio File','post id': post.id})
      this.homeUIService.openNextComponent(FullScreenAudioComponent, { data: posts })
    } else if (this.videoFormats.some(el => url.includes(el))) {
      console.log('Video File');
      mixpanel.track('Commitments-Open Documents', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Video File','post id': post.id})
      this.homeUIService.openNextComponent(FullScreenVideoComponent, { data: posts })
    } else {
      console.log('Document');
      mixpanel.track('Commitments-Open Documents', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Document File','post id': post.id})
      this.homeUIService.openNextComponent(FullScreenDocumentComponent)
    }
  }

  async reschedule(habits) {
    let posts, docLink;
    posts= habits?.document
   
    let doc = this.appState.get('singleDocument');
    if(posts?.id == doc?.id) {
      posts =this.appState.get('singleDocument')
    }
    const removeId = habits.id;
    this.closeOpenItems();
    this.habits = this.habits.filter(item => item.id !== removeId);
    this.appState.set('singleDocument', posts)
    docLink= posts?.editedDocumentUrl?posts?.editedDocumentUrl:posts?.toolLink;
    mixpanel.track("Commitments-Reschedule Habit", {'id': habits.id, 'pathName': habits.pathName, 'isConvertedToRoutine': habits.isConvertedToRoutine, 'screenId': habits.screenId, 'title': habits.title, 'startDay': habits.startDay})
    this.prepareCalendarParams(habits.title, this.routeService.innerHtmlToMobileAction(habits.text,docLink))
    if (this.hasNativeCalendar) {
      this.appState.set('scheduledHabitId', habits?.id);
     // this.getRoutines(this.currentUser?.id, this.currentPath.id);
      this.createCalendarEvent()
    } else {
      this.calendarParams.notes = this.routeService.innerHtmlToWebAction(habits.text,docLink)
      this.homeService.setCalendarData(this.calendarParams)
     
    const modal = await this.modalController.create({
      component: AlertWebactionCalendarComponent,
      animated: false,
      cssClass: this.isMobile?'custom-modal-size':'web-action-calender-modal'
    
    });
      await modal.present() 
      modal.onDidDismiss().then(() => {
    })
    }
   let input = {
       step_id:habits.stepId,
       screen_id:habits.screenId,
       screen_content_id:habits.screenContentId,
       // user_action_completion:false,
       user_action_scheduled_later:true,
       customization_id: habits?.customizationId,
       action_date_time:this.kyperApiService.formatDate()
      }
     this.kyperApiService.schedule_commit_action_kyper(input).subscribe(res => {
      // LUMBA-1344
      // this.spinnerService.off()
      this.getActions( this.currentPath.id);
       this.cdRef.detectChanges()
      //this.close()

    })
  

  }

  createCalendarEvent() {
    const success = function (message) { console.log('Success: ' + JSON.stringify(message)) }
    const error = function (message) { console.error('Error: ' + message) }

    // create an event interactively
    const w: any = window
    const calOptions = w.plugins.calendar.getCalendarOptions()
    const calendarList = w.plugins.calendar.listCalendars(success, error);
    const showAlertPrompt=true
    const daysCount = this.currentPath.lastDayOfContent() * 1.5 // LUMBA-1399
    // calOptions.recurrence = 'daily' // supported are: daily, weekly, monthly, yearly
    calOptions.recurrenceInterval = 1
    calOptions.firstReminderMinutes = 0
    calOptions.recurrenceEndDate = moment(new Date(), 'HH:mm').add(daysCount, 'day').toDate()

    this.calendarService.scheduleEvents(
      this.calendarParams.title,
      this.calendarParams.eventLocation,
      this.calendarParams.notes,
      this.calendarParams.startDate,
      this.calendarParams.endDate,
      calOptions,
      success,
      error,
      showAlertPrompt
    );
  }

  prepareCalendarParams(title: any, msg: String, routinelen: any = null, eventlen: string = null) {
    const start = moment(new Date(), 'HH:mm')
    const end = moment(new Date(), 'HH:mm').add(10, 'minute')
    var titleOfEvent = "Daily Learning Reminder"

    if (this.currentPath.names && this.currentPath.names?.titleOfEvent) {
      titleOfEvent = this.currentPath.names.titleOfEvent;
    } else {
      titleOfEvent = "Daily Learning Reminder"
    }

    this.calendarParams = {
      startDate: start.toDate(),
      endDate: end.toDate(),
      title: title, //updated title
      eventLocation: '',
      notes: msg,
      endEventTime: routinelen,
      frequency: eventlen
    }
  }

  async initModal(habit) {
    // this.appState.set('currentDay', habit.dayNum)
    habit.isCompleted = true;
    habit.scheduledLater = false;
    const modal = await this.modalController.create({
      component: CompletedReviewModalComponent,
      componentProps: { currentHabit: habit },
      cssClass: this.homeUIService.isDark() ? 'dark-theme-review-modal mobile-custom-to_do_list-forms' : 'light-theme mobile-custom-to_do_list-forms',
    });

    modal.onDidDismiss().then((modalDataResponse) => {
      if (modalDataResponse !== null) {
        this.cdRef.detectChanges()
        this.setActionsList()
      }
    });
    return await modal.present();
  }
  setActionsList() {
    let scheduleDay = this.appState.get("scheduleDayForCurrentStep")
    this.setDailyStepsArray(this.appState.get("DailyStepsData"));
    // this.habits = new Array(this.currentPath.lastDayOfContent())
    //   .fill(0)
    //   .map((value, index) => {
    //     const dayNum = index + 1;
    //     const habit = this.dailyStepsArray[index].habits
    //     if (habit) {
    //       return {
    //         id: habit.id,
    //         dayNum: habit.startDay, // LUMBA-1307
    //         title: habit.title,
    //         text: habit.text,
    //         casualDocumentId: habit?.casualDocumentId,
    //         documents: habit?.documents,
    //         scheduledLater: habit.confirmation < 1 && habit.scheduledLater > 0,
    //         confirmed: habit.confirmation > 0,
    //         isConvertedToRoutine: habit.isConvertedToRoutine,
    //         isCompleted: habit.isCompleted,
    //         screenId: "daily-content-screen-habit",
    //         startDay: habit.startDay,
    //         endDay: habit.endDay,
    //         pathName: this.currentPath.name
    //       };
    //     }
    //     return {
    //       id: null,
    //       dayNum: dayNum,
    //       title: null,
    //       text: null,
    //       casualDocumentId: null,
    //       documents:null,
    //       scheduledLater: false,
    //       confirmed: false,
    //       isConvertedToRoutine: false,
    //       isCompleted: false,
    //       screenId: "",
    //       startDay: 0,
    //       endDay: 0
    //     };
    //   });

    // this.habits =this.habits.filter(
    //   item => item.isCompleted !== true && (item?.dayNum<=scheduleDay && item?.startDay>0 && item?.startDay<=scheduleDay && this.dailyStepsArray[item?.startDay-1]?.stepStatus)
    // )
    this.habits = this.appState.get('todoActions');
    console.log('after path actions :', this.habits, this.habits?.length);
    this.unCommittedActionsList = this.habits.filter(item => !item.id || (!item.userActionCompletion && !item.userActionScheduledLater));
    console.log('data :', this.unCommittedActionsList);
    if(this.appState.get('expandNotCommittedActions') ){
      this.expandNotCommitted = true
    }
    if(this.appState.get('expandCompletedActions') ){
      this.expandCompleted = true
    }
  }
  setTab() {
    if (localStorage.getItem('commitmentTab') === "null" || localStorage.getItem('commitmentTab') === null) {
      //
      if(this.routineList?.length>0){
      this.routineList.forEach(element => {
        if (element.pathId === this.currentPath.id) {
          this.currentTab = 0;
          this.isEditRoutineEnabled = true;
        }
      })
      }
      else {
        this.currentTab = 1;
      }

    
    } 
    else if(this.routineList?.length ==0) {
      this.currentTab =1;
      this.isEditRoutineEnabled = false;
    }
    else {
      this.currentTab = Number(localStorage.getItem('commitmentTab'));
      this.isEditRoutineEnabled = false;
    }
    if(this.routineList?.length>0 && this.currentTab==0){
      this.isEditRoutineEnabled = true;
    }
    
  }

  onChange(event) {
    this.isCheckedAll = event.checked
  }

  getLevels(routine) {
    this.routineLevels = routine.habits
    this.routineId = routine.habitGroupId
    this.isExpanded = true
  }

  hideLevels() {
    this.isExpanded = false
  }

  getReps(item) {
    return item.repsData
  }

  logaRep(routine: any, level: any, index: any) {
    let repsCommitArray = routine.habits.filter(item => item.repsData)
    let repsArray = repsCommitArray.map(this.getReps)
    let totalRepsArray = Array.prototype.concat.apply([], repsArray);
    let totalLevelRepsArray = level.repsData.filter(item => item.is_completed === false)

    if (level.isHabitUnlocked === false) {
      this.tostrService.warning(this.i18n.t('Please complete previous level.'))
    } else {
     // this.spinnerService.on();
      this.commitService.setLoader(false);
      const requestData = {
        // 'user_id': this.currentUser.id,
        // 'path_id': routine.path_id,
        // 'routine_info_id': routine.routine_info_id,
        // 'level_id': level.id,
        // 'schedule_day': routine?.schedule_day,
        // 'feedback': localStorage.getItem('repLogText'),
        // 'step': index + 1
        habit_group_id: level.habitGroupId,
        habit_id: level.id,
        rep_feedback: localStorage.getItem('repLogText'),
        rep: level.repsData?.findIndex(item => item.is_completed === false)+1
      }

      // this.getRoutines(this.currentUser?.id, this.currentPath.id);
      this.routineService.replog(requestData).subscribe(
        (response) => {
          let object = null
         // this.spinnerService.off();
          this.commitService.setLoader(true);
          // add reply to the local path routine_info
          // if (response && response.data && response.data.habitGroupId) {
          //   object = this.fetchScreenTypeContent('routineInfo')?.find(q => q.id === response.data.habitGroupId)
          // }

          this.tostrService.success(this.i18n.t('Rep Logged!'))
          console.log('Response for feedback ', response)
          this.getRoutines(this.currentPath.id);
          this.cdRef.detectChanges()

          this.indexOfLevel = this.appState.get('indexOfLevel')
          var isLastRepLogged = level.repsData.filter(item => item.is_completed === true)

          const last = routine.habits[routine.habits.length - 1];
          this.appState.set('isTodoReps', undefined)
          // if (level.reps_commit.length == isLastRepLogged.length + 1  && last.id === level.id) {
          //   this.checkLastRep(routine)
          // } else
          if (totalLevelRepsArray.length - 1 === 0) {
            let unlockingHabitStepDetails = this.currentPath.findChapterStepByScreenContentId(this.dailyStepsArray, routine?.screenContentId)
            this.routineDay = unlockingHabitStepDetails?.stepPosition
            // this.routineDay = routine.schedule_day
            // this.appState.set('LevelNumber', level.level + 1)
             this.appState.set('levelUpdated', undefined)
            this.getCurrentRoutine(routine,level)
            // this.appState.set('showUpdatedScreens', true)
            this.openAlertGiveFeedbackCommitmentComponent(routine,level,index)
            // if (routine.path_id === this.currentPath.id) {
            //   this.appState.set('isLevelCommited',false);
            //   this.appState.set("allowScreenCount", undefined)
            //   // TODO: differentiate between mobile and web for routing
            //   if (this.isMobile) {
            //     this.route.navigate(['/content', this.routineDay], { queryParams: { startFromScreen: 'daily-content-screen-routine' } })
            //   } else {
            //     this.commitService.closeModals()
            //     setTimeout(() => {
            //       this.homeUIService.openNextComponent(DailyStepsContentWebModalV2Component,{currentDay: this.routineDay,startFromScreen: 'daily-content-screen-routine'},'web-daily-steps-custom-modal')                  
            //     }, 1100);
            //   }
              
            // } else {
            //   this.changeSubPath(routine.path_id, this.routineDay)
            // }
          } else {
            console.log('inside else:',);
          }

        },
        (error) => {
         // this.spinnerService.off()
          this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."));
          console.log('Error for feedback ', error)
        }
      )
    }
  }

  getCurrentRoutine(routine, level) {
    let unCheckedLevels = []
    // let routineInfo = this.fetchScreenTypeContent('routineInfo')
    // this.routineList?.forEach(currentRoutine => {
    //   if (currentRoutine.id === routine.habitGroupId) {
    //     currentRoutine.levels.forEach(routineLevel => {
          routine.habits.forEach(myLevel => {
            const match =routine.selectedHabitIds?.includes(myLevel.id)
            if (myLevel.id!=level.id  && (match.length === 0 && routine.selectedHabitIds?.length!=0)) {
             // myLevel.enabled = false;
              myLevel.enabled = false;
              unCheckedLevels.push({ 'id': myLevel.id, 'index': routine.habits.indexOf(myLevel) })
              unCheckedLevels =[...new Set(unCheckedLevels)];
            }
      //     });
      //   });
      // }
      let unselectedIndex = routine.habits.findIndex(item => item.id === level.id);
      let unCommittedLevel, unCommitedIndex;
      unCommittedLevel = this.homeUIService.getRoutineLockedLevel(routine)
      if (level?.isHabitUnlocked == true && unCommittedLevel) {
        unCommitedIndex = routine.habits.findIndex(item => item.id === unCommittedLevel?.id);
       this.indexOfLevel =unCommitedIndex
        this.appState.set('indexOfLevel', unCommitedIndex)
      }
      else {
        this.indexOfLevel = unselectedIndex;
         this.appState.set('indexOfLevel', unselectedIndex)
      }   
      // this.appState.set('levelUpdated', true)
    });
      unCheckedLevels= unCheckedLevels.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id));
      this.appState.set('unCheckedLevels',[...new Set(unCheckedLevels)] )
    this.selectedLevels = [];
    routine.habits.forEach(element => {
      let isPresentInUncheckedLevel = unCheckedLevels?.findIndex(item => item?.id === element.id)
       if (!routine.selectedHabitIds?.includes( element.id) && element.id ==level.id) {
        element.enabled = true;
        this.selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      }
       else if(routine.selectedHabitIds?.includes( element.id) || routine.selectedHabitIds?.length==0) {
         this.selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      }
    });
    this.selectedLevels=[...new Set(this.selectedLevels)]
    this.appState.set('selectedLevelIds', this.selectedLevels)
  }

  closeSingleHbit(eventData: { title: boolean }) {
    this.makeActive = eventData.title;
  }

  close() {
    this.makeActive = false;
    this.ngOnInit()
  }

  getClass() {
    return this.makeActive
  }

  checkLastRep(routine: any,level,index) {
    this.showAnimation()
    this.tostrService.success(this.i18n.t('Level Complete!'))
    this.appState.set('LevelNumber', undefined)
    this.appState.set("allLevelsCompleted", true);
    setTimeout(async () => {
 
      const alert = await this.alertController.create({
         cssClass: 'custom-alert-action',
         message: this.i18n.t('Has this level in this routine,')+" "+ routine?.title + " "+ this.i18n.t(", become a habit for you?"),
         
          buttons: [
            {
              text: this.i18n.t("No"),
              cssClass:'custom-alert-textcase',
              handler:()=>{
                this.makeHabit = false
                this.routineRepeatForLevel(routine,level,index);
                //this.openAlertGiveFeedbackCommitmentComponent(routine);
              }
            },
            {
              text: this.i18n.t("Yes"),
              cssClass:'custom-alert',
              handler:()=>{
                this.makeHabit = true
                this.levelSwitchCodeCheck(routine,level,index)
                //this.openAlertGiveFeedbackCommitmentComponent(routine);
              }
            }
           ],
        });
        await alert.present();
    }, 1500);

  }

  levelSwitchCodeCheck(routine, level, index) {
    let previousLevel = null;
    routine?.habits?.forEach((sublevel,index) => {
      if (sublevel.level == level.level) {
        console.log("index", index);
        if (index != 0) {
          //    previousLevel = routine.routine[index-1]
          // }
          for (let i = index - 1; i >= 0; i--) {
            if (!routine.habits[i]?.isHabitCompleted) {
              previousLevel = routine.habits[i];
              break;
            }
          }
        }
      }
    })
    // if (level.level != 1) {
    //   previousLevel =  routine.routine[level.level-2]
    // }
    if (this.appState.get('IsRepsAppendAfterReoptCommit') == true) {
        this.appState.set('IsRepsAppendAfterReoptCommit', undefined)
    }
    if (this.appState.get('isLevelClosedBeforeCommit') == true) {
      this.appState.set('isLevelClosedBeforeCommit',undefined)
    }
    let previousLevelRepsArray;
    if (previousLevel) {
      previousLevelRepsArray = previousLevel?.repsData?.filter(item => item?.is_completed === false)
    }
    let repsCommitArray = routine.habits.filter(item => item.repsData)
    let repsArray = repsCommitArray.map(this.getReps)
    let totalRepsArray = Array.prototype.concat.apply([], repsArray);
    let totalLevelRepsArray, isLastRepLogged
    this.indexOfLevel = this.appState.get('indexOfLevel')
    if (level?.repsData) {
       totalLevelRepsArray = level.repsData.filter(item => item.is_completed === false)
       isLastRepLogged = level.repsData.filter(item => item.is_completed === true)
    }
    else if (level?.repsData) {
       totalLevelRepsArray = level.repsData.filter(item => item?.isCompleted?item?.isCompleted === false :item?.is_completed === false)
       isLastRepLogged = level.repsData.filter(item => item?.isCompleted?item?.isCompleted === true :item?.is_completed === true)
    }
    const last = routine.habits[routine.habits.length - 1];
    this.appState.set('isTodoReps', undefined)
    let unCommittedLevel;
    if (level?.isHabitUnlocked == false) {
      unCommittedLevel = this.homeUIService.getRoutineUnselectedLevel(routine);
    }
    else {
      unCommittedLevel = this.homeUIService.getRoutineLockedLevel(routine)
    }
    console.log("unCommittedLevel changes",unCommittedLevel)
    if (unCommittedLevel?.level && (last.id !== level.id || !level?.isHabitUnlocked || !level?.isUnlocked)) {
      let levelTitle;
      if (level?.isHabitUnlocked == true && unCommittedLevel) {
        this.appState.set('LevelNumber', unCommittedLevel?.level)
        this.appState.set('unCheckedLevelId', unCommittedLevel?.id);
        levelTitle = unCommittedLevel?.level?.title?  unCommittedLevel?.level?.title: unCommittedLevel?.title
      } 
      else {
        this.appState.set('LevelNumber', level.level)
        this.appState.set('unCheckedLevelId',level?.id);
        levelTitle = level?.title;
      }
      this.appState.set('levelUpdated', true)
      this.getCurrentRoutine(routine,level)
      this.appState.set('showUpdatedScreens', true)
      this.appState.set('isLevelClosedBeforeCommit', true)
      let openedRoutineInfo = {
            routine: routine,
            habits: routine?.habits[this.indexOfLevel]
      }
      this.appState.set('routinneLevelInfo', openedRoutineInfo)
      let unlockingHabitStepDetails = this.currentPath.findChapterStepByScreenContentId(this.dailyStepsArray, routine?.screenContentId)
      console.log("unlocking HabbitStepDetails", unlockingHabitStepDetails)
       this.routineDay = unlockingHabitStepDetails?.stepPosition
      localStorage.setItem('unlockingHabitStepDetails', JSON.stringify(unlockingHabitStepDetails))
      this.commitService.dismissAllModals().then(()=>{
     this.homeUIService.dismissAllModals().then(() => {
      if (routine.pathId === this.currentPath.id) {
        this.appState.set('isLevelCommited', false);
        this.appState.set("allowScreenCount", undefined)
        // TODO: differentiate between mobile and web for routing
        if (this.isMobile) {
          //if (level?.isUnlocked == false) {
            this.appState.set('UnlockedLevelTitle',levelTitle)
            this.route.navigate(["/alert-unlock-component"], {
          state: {
                data: unlockingHabitStepDetails?.stepPosition
          },
        });
          // }
          // else {
          //   this.route.navigate(['/content', this.routineDay], { queryParams: { startFromScreen: 'daily-content-screen-routine' } })
          // }
        } else {
          this.commitService.closeModals()
          //if (level?.isUnlocked == false) {
            this.appState.set('UnlockedLevelTitle',levelTitle)
            setTimeout(() => {
              this.homeUIService.openDailyStepsComponent(AlertUnlockLevelComponent, { nextLevelData: unlockingHabitStepDetails?.stepPosition }, 'web-daily-steps-custom-modal')
            }, 600);
          // }
          // else {
          //   setTimeout(() => {
          //     this.homeUIService.openNextComponent(DailyStepsContentWebModalV2Component, { currentDay: this.routineDay, startFromScreen: 'daily-content-screen-routine' }, 'web-daily-steps-custom-modal')
          //   }, 1100);
          // }
        }
         this.appState.set("levelUpdateData", undefined); 
      } else {
        this.changeSubPath(routine.pathId, unlockingHabitStepDetails?.stepPosition,level?.isHabitUnlocked?'alertUnlock':'daily-content-screen-routine',levelTitle)
      }
               
     })
        })
    }
    // else if (previousLevelRepsArray && previousLevelRepsArray?.length != 0 || previousLevel?.isHabitCompleted == false) {
    //   this.toasterService.warning(this.i18n.t('Please complete previous uncompleted level reps in To-Do list section to unlock .'))
    // }
  }
  async routineRepeatForLevel(routine,level,index) {
       const alert = await this.alertController.create({
               
                 cssClass: 'habit-alert',
               
                 //message: this.i18n.t('Do you want to repeat part of this habit to continue building the habit of')+" "+routine?.routine_info?.title,
                 message: this.i18n.t('Do you want to continue building this habit for the next week?'),
                  buttons: [
                    {
                      text: this.i18n.t("No"),
                      cssClass:'custom-cancle-btn',
                      handler:()=>{
                       this.levelSwitchCodeCheck(routine,level,index)
                      }
                    },
                    {
                      text: this.i18n.t("Yes"),
                      cssClass:'custom-yes-alert',
                      handler: () => {
                        this.modalController.dismiss();
                        this.reoptTheLevelCue(routine,level,index)
                        //this.onSubmit(routine,level);
                      }
                    }
                   ],
                });
                await alert.present();
 }

  async reoptTheLevelCue(routine, level,index) {
    const modal= await this.modalController.create({
      component: ReoptHabitLevelModalComponent,
      componentProps: {data: {
                dataKey: { routine: level },
        }
      },
      cssClass: 'reopt-habit-level-modal',
      backdropDismiss:false
    })
    await modal.present();
            modal.onWillDismiss().then((result) => {
              console.log("result", result);
              //this.appState.set('isNotificationViewed',true)
              var routineAnswer = level.commitmentStatement;
              if (result?.data?.status === "confirm") {
                //yes
                this.findLevelId(routine,level)
                if (level) {
                  if (level.isSingleEvent === null) {
                    this.commitService.earlierOptedNotsureTimesDays(routineAnswer,
                      routine,
                      level,level?.isSingleEvent)
                  }
                  else {
                    // this.commitService.openRoutineCalendarForLevel(
                    //   level.isSingleEvent ? false : true,
                    //   routineAnswer,
                    //   routine,
                    //   level,
                    // ); //false
                    this.commitService.sameCueOptSelection(level?.isSingleEvent,
                      routineAnswer,
                      routine,
                      level)
                  }
                  this.appState.set("isConfirmed", true);
                }
              } else if (result?.data?.status === "change") {
                //No, change cue
                this.appState.set("changeCue", true);
                this.appState.set('levelEdit', true)
                this.appState.set("isRoutineEdited", true);
                 this.onSubmit(routine,level)
              } else if (result?.data?.status === "turnOff") {
                //No, turn off reminders, switch to next level if present
                this.levelSwitchCodeCheck(routine,level,index)
              }
            });
  }

  async openAlertGiveFeedbackCommitmentComponent(routine, level, index) {
    this.showAnimation()
    this.tostrService.success(this.i18n.t('Habit level Complete!'))
    const modal= await this.modalController.create({
      component: AlertGiveFeedbackCommitmentComponent,
      componentProps: {levelTiltle:level?.title},
      cssClass: this.isMobile ? 'custom-alert-give-feedback-modal' : 'web_routine_feedback_modal',
      enterAnimation: this.animationService.slideInLeftEnterAnimation,
      leaveAnimation: this.animationService.SlideOutRightLeaveAnimation
    })
    this.homeUIService.setModalStack(modal);
    await modal.present();
   modal.onDidDismiss().then((res)=>{
     if(res){
      this.giveFeedback(routine,level,index)
     }
   })
  }
  giveFeedback(routine: any,level,index) {
    routine =this.homeUIService.getRoutineByLevel(level, this.routineList)
    let currentLevelIndex= routine?.habits?.findIndex(item => item.id === level?.id);
    level = routine?.habits[currentLevelIndex]
    var step_rating = localStorage.getItem("commitmentRating1")
    var step_comment = localStorage.getItem("commitmentFeedback")
    try {
      const requestData = {
        // 'user_id': this.currentUser.id,
        // 'path_id': this.currentPath.id,
        // 'step_score': step_rating,
        // 'step_comment': step_comment,
        // 'habitGroupId': routine.habitGroupId,
        // 'is_routine_complted':routine?.routine?.length>0?(routine?.routine[routine?.routine?.length-1].isHabitCompleted?true:false):(routine?.levels?.length>0?routine?.levels[routine?.levels?.length-1]?.isHabitCompleted?true:false:false)
          habit_group_id: routine.habitGroupId,
      habit_id:level.id,
      is_habit_completed: routine?.habits?.length > 0 &&routine.habits.filter(habit => habit?.isHabitCompleted).length === routine.habits.length,
      habit_rating:step_rating,
      habit_feedback: step_comment
      }
      //this.spinnerService.on()
      if (requestData.habit_feedback == '' && requestData.habit_rating == '') {
        //this.spinnerService.off();
      } else {
        this.routineService.routineFeedback(requestData).subscribe(
          async (response) => {
            console.log('respose', response, step_rating == '5')
            this.getRoutines(this.currentPath.id);
            this.cdRef.detectChanges()
            //this.spinnerService.off();
            if (step_rating == '5') {
              this.levelSwitchCodeCheck(routine, level, index);
            }

            else {
               this.routineRepeatForLevel(routine,level,index)
            }
          
          },
          (error) => {
           // this.spinnerService.off()
            this.tostrService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          }
        )
      }

    } catch (o_O) {
      console.log(o_O);
    }

  }

  findLevelId(routine: any, checkedLevel: any) {
    console.log('routine :', routine);
    let someArray = []
    let level_ids =[];
    routine.habits.forEach(element => {
      if (element.id == checkedLevel.id) {
        someArray.push(element)
        level_ids.push(element.id)
      }
    });
    this.appState.set('IsRepsAppendAfterReoptCommit',true)
    this.appState.set('LevelNumber', someArray[0].level)
    let unselectedIndex = routine.habits.findIndex(item => item.id === checkedLevel.id);
    this.appState.set('indexOfLevel', unselectedIndex)   
    this.appState.set('currentLevel', someArray[0])
    this.appState.set('levelUpdated', undefined)

  }

  onSubmit(routine,level) {
    // this.appState.set("allowScreenCount", true)
    this.appState.set('levelEdit', true)
    let checkUnfinishedLevels =this.homeUIService.getUnFinishedLevelBeforeRecommit(routine)
    if (checkUnfinishedLevels && checkUnfinishedLevels?.length > 0) {
      this.toasterService.warning(this.i18n.t('Please complete uncompleted level reps in To-Do list section before re-commit.'))
    }
    else {
      this.getCurrentRoutine(routine, level)
      this.appState.set('showUpdatedScreens', true)
      this.appState.set('LevelNumber', level.level)
      this.findLevelId(routine, level)
      this.appState.set('levelUpdated', true)
      this.appState.set('hidePrevScreen', true);
      this.appState.set("allowScreenCount", undefined)
      let unselectedIndex = routine.habits.findIndex(item => item.id === level.id);
      this.appState.set('indexOfLevel', unselectedIndex)
      let unlockingHabitStepDetails = this.currentPath.findChapterStepByScreenContentId(this.dailyStepsArray, routine?.screenContentId)
      console.log("unlocking HabbitStepDetails", unlockingHabitStepDetails)
      let routineDay = unlockingHabitStepDetails?.stepPosition
      this.commitService.dismissAllModals().then(() => {
        if (routine.pathId === this.currentPath.id) {
          this.appState.set("reviewingStepIndex", unlockingHabitStepDetails?.stepIndex);
          let chapterPosition= unlockingHabitStepDetails?.chapterIndex
          if (this.isMobile) {
            this.homeUIService.dismissAllModals().then(() => {
              this.route.navigate(['/content', routineDay], { queryParams: { startFromScreen: 'daily-content-screen-meet-cue', currentOpenedChapter: chapterPosition,currentOpenedStep: unlockingHabitStepDetails?.stepIndex } })
            })
          } else {
            this.homeUIService.dismissAllModals().then(() => {
              this.homeUIService.openNextComponent(DailyStepsContentWebModalV2Component, { currentDay: routineDay, startFromScreen: 'daily-content-screen-meet-cue',currentOpenedChapter:chapterPosition }, 'web-daily-steps-custom-modal')
            })
          }
        }
        else {
          localStorage.setItem('unlockingHabitStepDetails', JSON.stringify(unlockingHabitStepDetails))
          this.changeSubPath(routine.pathId, routineDay,'daily-content-screen-meet-cue')
        }
      });
    }
  }


  private changeSubPath(pathId: number, routineDay: number,startFromScreenId,levelTitle?) {

    const request = {
      'user_id': this.currentUser.id,
      'active_path_id': pathId
    }

    this.homev5Service.subpathchange(request, 'Actionhub- Commitments').subscribe(
      (response) => {
        this.appState.set('isAllPaths', false)
        this.appState.set("screensViewed", undefined);
        this.appState.set('stepsArray', undefined)
        this.appState.set('stepObject', undefined)
        this.refresh()
        let data = response["data"];
        try {
          let isOnboardContentPresent = data.onboardingSurvey || data?.isIntroVideo;
          if (data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted?.length > 0 && isOnboardContentPresent) {
            let value = data['isonboardingcompleted'][0];
            this.isonboardingcompleted = value["isonboardingcompleted"];
            if ((this.isonboardingcompleted === false || this.isonboardingcompleted === null) && isOnboardContentPresent) {
              this.route.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data?.isIntroVideo } });                          
            } else if (this.isonboardingcompleted === true) {
              this.appState.set("allowScreenCount", undefined)
              this.appState.set('levelUpdated', true)
              if (levelTitle) {
                this.appState.set('isLevelClosedBeforeCommit', true)
              }
              let chapterPosition= JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.chapterIndex
              if (this.isMobile) {
                setTimeout(() => {
                  if (startFromScreenId == 'alertUnlock') {
                    this.appState.set('UnlockedLevelTitle', levelTitle)
                    this.route.navigate(["/alert-unlock-component"], {
                      state: {
                        data: routineDay
                      },
                    });
                  }
                  else {
                    let stepIndex= JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex
                    this.appState.set("reviewingStepIndex", stepIndex);
                    localStorage.removeItem('unlockingHabitStepDetails')
                    this.route.navigate(['/content', routineDay], { queryParams: { startFromScreen: startFromScreenId, currentOpenedChapter: chapterPosition ,currentOpenedStep: stepIndex} })
                  }
                }, 3500);
              } else {
                this.commitService.closeModals()
                if (startFromScreenId == 'alertUnlock') {
                  this.appState.set('UnlockedLevelTitle', levelTitle)
                  setTimeout(() => {
                    this.appState.set("reviewingStepIndex", JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex);
                    localStorage.removeItem('unlockingHabitStepDetails')
                    this.homeUIService.openDailyStepsComponent(AlertUnlockLevelComponent, { nextLevelData: routineDay }, 'web-daily-steps-custom-modal')
                  }, 3800);
                }
                else {
                  setTimeout(() => {
                    this.homeUIService.openNextComponent(DailyStepsContentWebModalV2Component, { currentDay: routineDay, startFromScreen: startFromScreenId,currentOpenedChapter:chapterPosition }, 'web-daily-steps-custom-modal')
                  }, 3800);
                }
              }
            }
          } else if(data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted.length===0 && isOnboardContentPresent){
              this.route.navigate(["/onboarding"], { state: { onboardingSurvey: data?.onboardingSurvey, isIntroVideo: data?.isIntroVideo } });                          
          } else {
            console.log('remove', this.isonboardingcompleted)
            this.homeUIService.checkSubpathStatus();
            if (levelTitle) {
              this.appState.set('isLevelClosedBeforeCommit', true)
            }
            let chapterPosition= JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.chapterIndex
            this.appState.set("allowScreenCount", undefined)
            this.appState.set('levelUpdated', true);
            if (this.isMobile) {
              setTimeout(() => {
                if (startFromScreenId == 'alertUnlock') {
                  this.appState.set('UnlockedLevelTitle', levelTitle)
                  this.route.navigate(["/alert-unlock-component"], {
                    state: {
                      data: routineDay
                    },
                  });
                }
                else {
                  let stepIndex = JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex;
                  this.appState.set("reviewingStepIndex",stepIndex);
                    localStorage.removeItem('unlockingHabitStepDetails')
                  this.route.navigate(['/content', routineDay], { queryParams: { startFromScreen: startFromScreenId , currentOpenedChapter: chapterPosition,currentOpenedStep: stepIndex} })
                }
              }, 3500);
              } else {
                this.commitService.closeModals()
                if (startFromScreenId == 'alertUnlock') {
                  this.appState.set('UnlockedLevelTitle', levelTitle)
                  setTimeout(() => {
                    this.homeUIService.openDailyStepsComponent(AlertUnlockLevelComponent, { nextLevelData: routineDay }, 'web-daily-steps-custom-modal')
                  }, 3800);
                }
                else {
                  setTimeout(() => {
                    this.appState.set("reviewingStepIndex", JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex);
                    localStorage.removeItem('unlockingHabitStepDetails')
                    this.homeUIService.openNextComponent(DailyStepsContentWebModalV2Component, { currentDay: routineDay, startFromScreen: startFromScreenId ,currentOpenedChapter:chapterPosition}, 'web-daily-steps-custom-modal')
                  }, 3800);
                }
              }
          }
        } catch (error) {
          this.route.navigate(['/main']);
        }
        this.refresh()
      }, (error) => {
        console.log("Response of path changed ", error)
      }
    )
  }

  refresh() {
    return new Promise(resolve => {
      // here to fetch the data and rerender the contents.
      this.appState.refreshMainComponent.emit()
      setTimeout(resolve, 0)
    })
  }


  getRoutineLevelInfo(routine,index)
  {
    this.web_todoLevelsList[index] = this.homeUIService.getRoutineLevel(routine)
   // console.log("this.web_todoLevelsList",routine,this.web_todoLevelsList,index)
    if(this.web_todoLevelsList[index]?.length>0) {
      return true
    }
    else {
      return false;
    }
  }
   
  getLockedRoutineLevelInfo(routine,index)
  {
    this.web_todoLockedLevelsList[index] = this.homeUIService.getRoutineLockedLevelsList(routine)
    //console.log("this.web_todoLevelsList",routine,this.web_todoLockedLevelsList[index],index)
    if(this.web_todoLockedLevelsList[index]?.length>0) {
      return true
    }
    else {
      return false;
    }
  }

  getCompletedRoutineLevels(routine, index) {
    this.web_completedLevelsList[index] = this.homeUIService.getCompletedLevels(routine)
    if (this.web_completedLevelsList[index]?.length>0) {
      return true
    }
    else {
      return false;
    }
  }

  openOptions(item: IonItemSliding,index,type) {
    this.closeOpenItems(index);
    if(type=='action'){
      this.actionCommitmentIndex =index;
    }
    else {
      this.habitCommitmentIndex =index;
    }
    item.open('start');
  }

  closeOpenItems(index?) {
    if(this.slidingItem){
      this.slidingItem.forEach((item)=>{
       item.closeOpened();
       this.actionCommitmentIndex =null;
       this.habitCommitmentIndex = null;
      });
    }   
  }

  getTitle(title) {
    let prefixTranslated = this.i18n.t("My commitment: ")
    return title?.startsWith(prefixTranslated)
      ? title?.slice(prefixTranslated.length)?.trim()
      : title;
  }

  getLevelTitle(level){
    return level?.title
  }

  getThePreviousCommitedOne(routine, level, currentLevelIndex) {
    let queuedLevels = [];
    let activeCommitedLevels = [];
    queuedLevels = routine?.habits?.filter((subLevel) => !subLevel.isHabitCompleted && !subLevel?.isHabitUnlocked && routine?.selectedHabitIds.includes(subLevel.id))
    activeCommitedLevels = routine?.habits?.filter((subLevel) => !subLevel.isHabitCompleted && subLevel?.isHabitUnlocked)
     if (queuedLevels.length === 0 || currentLevelIndex < 0 || currentLevelIndex >= queuedLevels.length) {
        return null;
    }
    // If this is the first queued level
    if (currentLevelIndex === 0) {
        if (activeCommitedLevels?.length === 1) {
            return `‘${activeCommitedLevels[0]?.title}’`;
        } else if (activeCommitedLevels.length > 1) {
            const activeRefs = activeCommitedLevels.map(level => `‘${level?.title}’`).join(' or ');
            return activeRefs;
        }
        else if (activeCommitedLevels?.length == 0) {
          return 0;
        }
    }

    // For all other queued levels, reference the previous queued level
    return `‘${queuedLevels[currentLevelIndex - 1]?.title}’`;

  }

  openDocbyTool(post,event) {
    event.preventDefault(); // Prevent default behavior
    event.stopPropagation(); // Stop event bubbling
  
    const docLink = event.currentTarget as HTMLElement;
  
    if (docLink) {
      this.homeUIService.openDocument(post, this.dialog, this.currentPath.name);
    }
  }

  async openModal(event: Event, action){
    //event.stopPropagation();
    this.actionId = action.id
    this.checked = true
    this.habitConfirm_condensed(action);
  }

  habitConfirm_condensed(habit) {
    var isHabitComplete = habit?.userActionCompletion
       let input = {
      step_id:habit.stepId,
      screen_id:habit.screenId,
      screen_content_id:habit.screenContentId,
      user_action_completion:true,
      customization_id: habit?.customizationId,
      action_date_time:this.kyperApiService.formatDate()
     }
    try {
      this.kyperApiService.schedule_commit_action_kyper(input).subscribe(res => {
        // this.spinnerService.off()
        habit.userActionCompletion = true
        habit.userActionScheduledLater = false
        // this.isTodoVisible = false;
        const actionKey = `${habit.id}`;
        this.closeOpenItems(); 
        // setTimeout(() => {
          this.isTodoVisible[actionKey] = true;
        // }, 600);
        
        setTimeout(() => {
          this.isTodoVisibleParent[actionKey] = true;
        }, 1000);
        this.cdRef.detectChanges()
           try {
      if (this.currentPath.enabledAttributes?.feedback && !isHabitComplete ) {
        setTimeout(() => {
        this.inithabitModal(habit)
        }, 100);
      }
      else {
         this.appState.set('updateActionPoints',true)
        this.closeOpenItems();
        this.getActions( this.currentPath.id,'habitConfirm_condensed');
        //this.setActionsList();
        this.cdRef.detectChanges()
      }
    } catch (o_O) {
      console.log(o_O);
    }
      })
    } catch (o_0) {
      console.log('Errors ', o_0)
    }
 
  }

  /**
   * Opens the micro-action coach ("practice bot") for a to-do list Micro-action, using the
   * same modal styling as the in-step web modal.
   */
  /**
   * The action's own switch for voice practice. The to-do list payload does not carry the flag,
   * so it is read from the path content for that screen_content_id — the same place the in-step
   * coach reads it from (`screenContents.content.enableVoicePractice`).
   */
  canVoicePractice(action: any): boolean {
    // Practice Bot runs through the coach for now, so the coach being off puts it out of reach —
    // even though the two toggles are otherwise independent. Undefined means on, as elsewhere.
    if (this.client?.enableFoozi === false) { return false; }
    const onAction = action?.enableVoicePractice;
    if (onAction !== undefined && onAction !== null) { return !!onAction; }
    return this.voicePracticeScreenIds().has(String(action?.screenContentId ?? ''));
  }

  /**
   * screen_content_ids whose content enables voice practice. Built once from the path data — the
   * chips ask per action on every change-detection pass, so this cannot be a walk of the tree.
   */
  /**
   * The one way to swap in path data. Switching sub-path (changeSubPath) or refreshing the list
   * replaces the content the eligibility set was built from, so a stale set would describe the
   * previous path and show or hide a Practice control against the wrong actions.
   */
  private setDailyStepsArray(value: any) {
    this.dailyStepsArray = value;
    this.voicePracticeIds = null;
  }

  private voicePracticeScreenIds(): Set<string> {
    if (this.voicePracticeIds) { return this.voicePracticeIds; }

    const chapters = this.dailyStepsArray ?? [];
    const ids = new Set<string>();
    for (const chapter of chapters) {
      for (const step of chapter?.steps ?? []) {
        for (const screen of step?.screens ?? []) {
          const contents = screen?.screenContents;
          if (contents?.content?.enableVoicePractice) { ids.add(String(contents.id)); }
        }
      }
    }
    // Only remember the answer once there is path data to have answered from.
    if (chapters.length) { this.voicePracticeIds = ids; }
    return ids;
  }

  async openPracticeBot(event: Event, action) {
    event?.stopPropagation();
    const modal = await this.modalController.create({
      component: PracticeBotModalComponent,
      componentProps: { action },
      cssClass: this.isMobile ? 'pratice-bot-custom-modal' : 'web-daily-steps-custom-modal web-pratice-bot-custom-modal'
    });
    modal.onDidDismiss().then((modalDataResponse) => {
      const data = modalDataResponse?.data;
      // Committing an action goes through the calendar flow, which lives here.
      if (data?.practiceIntent === 'reschedule') {
        this.reschedule(data?.action || action);
        return;
      }
      if (data?.actionCompleted) {
        this.appState.set('updateActionPoints', true);
        this.closeOpenItems();
        this.getActions(this.currentPath.id, 'habitConfirm_condensed');
        this.cdRef.detectChanges();
      }
    });
    return await modal.present();
  }

  async inithabitModal(habit) {
    // this.appState.set('currentDay', habit.startDay)
    const modal = await this.modalController.create({
      component: CompletedReviewModalComponent,
       componentProps: { currentHabit: habit },
      cssClass: this.isMobile?'mobile-custom-to_do_list-forms': 'web_feedbackForm_modal'
    });
    modal.onDidDismiss().then((modalDataResponse) => {
      if (modalDataResponse !== null) {
        this.appState.set("isCommented", false)
      }
      this.appState.set('updateActionPoints',true)
      this.closeOpenItems();
      this.getActions(this.currentPath.id,'inithabitModal')
    //  this.setActionsList();
    });
    return await modal.present();
  }

  expandCompletedActions(){
    setTimeout(() => {
      this.expandCompleted = !this.expandCompleted;
      this.appState.set('expandCompletedActions', this.expandCompleted);
    }, 10);
  }

  expandNotCommittedActions(){
    setTimeout(() => {
      this.expandNotCommitted = !this.expandNotCommitted;
      this.appState.set('expandNotCommittedActions', this.expandNotCommitted);
    }, 10);
  }

  expandEdit(){
    this.showEditOptions = true
    this.showEditHabits = true
  }

  cancelEdit(){
    this.showEditOptions = false
    this.showEditHabits = false
  }

  deleteAction(event: Event, action){
    event.stopPropagation();
    const requestData = {
      action_id: action.id,
      //user_id: this.currentUser.id
    }
    this.routineService.deleteUserAction(requestData).subscribe(
      (response) => {
        this.cdRef.detectChanges();
        this.getActions(this.currentPath.id,'deleteAction',action);
        // this.routineService.deleteActionFromPath(action,this.habits)
      },
      (error) => {
        console.log('Error for routines ', error)
      })
  }

  deleteHabit(event: Event, habit){
    console.log('routine :', habit);
    event.stopPropagation();
  }

  async showFeedbackForm(subItem) {
    this.levelId = subItem?.id;
    let currentRoutine = this.homeUIService.getRoutineByLevel(subItem, this.routineList);
    let repsIndex = subItem?.repsData.findIndex((item) => item.is_completed === false); 
    if (repsIndex > -1) {
      const routineKey = `${currentRoutine.id}`;
      const levels = this.web_todoLevelsList[this.routineList.indexOf(currentRoutine)];
  
      this.closeOpenItems();
            
      // Immediately hide the routine if it is the last one regardless of commitment
      // const isLastRoutine = subItem?.reps_commit.length - 1;
      // if (repsIndex == isLastRoutine) {
      //   this.hiddenRoutines[this.levelId] = true;
      // }
      
      setTimeout(async () => {
      const isLastRoutine = subItem?.repsData?.length - 1;
        if (repsIndex == isLastRoutine) {
          this.hiddenRoutines[this.levelId] = true;
          setTimeout(() => {
            this.hiddenRoutinesParent[this.levelId] = true;
          }, 1000);
      }

      const modal = await this.modalController.create({
        component: FeedbackFormComponent,
        componentProps: {
          mainItem: currentRoutine,
          subItem: subItem,
          index: repsIndex
        },
        cssClass: this.isMobile ? 'mobile-custom-to_do_list-forms' : 'web_feedbackForm_modal'
      });
      // this.closeOpenItems();
      modal.onDidDismiss().then((modelData) => {
        if (modelData !== null && modelData.data !== undefined) {
          this.onLogaRep.emit(modelData.data);
          this.logaRep(currentRoutine, subItem, repsIndex);

          // After logging rep, re-check if all levels are committed and update hiddenRoutines
          // if (this.areAllLevelsCommitted(levels)) {
          //   this.hiddenRoutines[routineKey] = true;
          // } else {
          //   this.hiddenRoutines[routineKey] = false;
          // }
        }
      });
      return await modal.present();
    }, 500);
  
    } else {
      this.cdRef.detectChanges();
      console.log('Completed level');
    }
  }
  
  // This method should be in your component class
  areAllLevelsCommitted(levels: any[]): boolean {
    return levels?.every(level =>
      level.repsData?.every(commit => commit.is_completed)
    );
  }
  
  repeatAction(event: Event, action){
    console.log('repeat action')
    this.isTodoVisible[`${action.id}`] = false;
    this.isTodoVisibleParent[`${action.id}`] = false;
   // event.stopPropagation();
    this.reschedule(action)
    const requestData = {
      action_id: action.id,
      // user_id: this.currentUser.id
    }
    this.routineService.repeatUserAction(requestData).subscribe(
      (response) => {
        this.showActionCheckbox = true
        this.cdRef.detectChanges();
        // this.getRoutines(this.currentUser?.id, this.currentPath.id,action.id);
      },
      (error) => {
        console.log('Error for routines ', error)
      })
  }

  toggleExpandAction(index: number) {
    if (this.actionClicked[index]) {
      setTimeout(() => {
        this.actionClicked[index] = !this.actionClicked[index]
      }, 200);
    }
    else {
          this.actionClicked[index] = !this.actionClicked[index]
    }
    this.isItemExpanded[index] = !this.isItemExpanded[index];
  }
  toggleExpandUnSelectedRoutineLevel(index) {
     if (this.unSelectedLevelClicked[index]) {
      setTimeout(() => {
        this.unSelectedLevelClicked[index] = !this.unSelectedLevelClicked[index]
      }, 200);
    }
    else {
          this.unSelectedLevelClicked[index] = !this.unSelectedLevelClicked[index]
    }
    this.isUnSelectedLevelExpanded[index] = !this.isUnSelectedLevelExpanded[index];
  }
  toggleExpandRoutine(index: number) {
     if (this.routineClicked[index]) {
      setTimeout(() => {
        this.routineClicked[index] = !this.routineClicked[index]
      }, 200);
    }
    else {
          this.routineClicked[index] = !this.routineClicked[index]
    }
    this.isRoutineExpanded[index] = !this.isRoutineExpanded[index];
  }
  toggleCompletedAction(index: number) {
     if (this.completedActionClicked[index]) {
      setTimeout(() => {
        this.completedActionClicked[index] = !this.completedActionClicked[index]
      }, 200);
    }
    else {
          this.completedActionClicked[index] = !this.completedActionClicked[index]
    }
    this.isActionExpanded[index] = !this.isActionExpanded[index];
  }
  toggleExpandncAction(index: number) {
      if (this.noncompletedActionClicked[index]) {
      setTimeout(() => {
        this.noncompletedActionClicked[index] = !this.noncompletedActionClicked[index]
      }, 200);
    }
    else {
          this.noncompletedActionClicked[index] = !this.noncompletedActionClicked[index]
    }
    this.ncAction[index] = !this.ncAction[index];
  }
  toggleExpandncAction1(index: number) {
      if (this.noncompletedActionClicked1[index]) {
      setTimeout(() => {
        this.noncompletedActionClicked1[index] = !this.noncompletedActionClicked1[index]
      }, 200);
    }
    else {
          this.noncompletedActionClicked1[index] = !this.noncompletedActionClicked1[index]
    }
    this.ncAction1[index] = !this.ncAction1[index];
  }
  toggleExpandUnCommitedRoutineLevel(index) {
      if (this.isUncommitedRoutineLevelClicked[index]) {
      setTimeout(() => {
        this.isUncommitedRoutineLevelClicked[index] = !this.isUncommitedRoutineLevelClicked[index]
      }, 200);
    }
    else {
          this.isUncommitedRoutineLevelClicked[index] = !this.isUncommitedRoutineLevelClicked[index]
    }
    this.uncommitedRoutineLevel[index] = !this.uncommitedRoutineLevel[index];
  }
  toggleExpandUnCommitedRoutine(index) {
      if (this.isUncommitedRoutineClicked[index]) {
      setTimeout(() => {
        this.isUncommitedRoutineClicked[index] = !this.isUncommitedRoutineClicked[index]
      }, 200);
    }
    else {
          this.isUncommitedRoutineClicked[index] = !this.isUncommitedRoutineClicked[index]
    }
    this.uncommitedRoutine[index] = !this.uncommitedRoutine[index];
  }
  toggleExpandCompletedRoutine(index) {
      if (this.isUncompletedRoutineClicked[index]) {
      setTimeout(() => {
        this.isUncompletedRoutineClicked[index] = !this.isUncompletedRoutineClicked[index]
      }, 200);
    }
    else {
          this.isUncompletedRoutineClicked[index] = !this.isUncompletedRoutineClicked[index]
    }
    this.completedRoutine[index] = !this.completedRoutine[index];
  }
  recommitcompletedHabit(event, routine,habitLevel) {
     const requestData = {
                // 'user_id': routine.user_id,
                // 'path_id': routine.path_id,
                // 'is_reset': true,
                // 'habitGroupId': routine.habitGroupId
                habit_id: habitLevel?.id,
                habit_group_id: routine?.habitGroupId
              }
              if (!requestData.habit_group_id) {
                return true;
              } else {
                this.routineService.editRoutine(requestData).subscribe(
                  (response) => {
                    console.log('status', response);
                    this.cdRef.detectChanges();
                    this.editRoutineStatus()
                    this.commitUncompleteHabit(event, routine);
                  },
                  (error) => {
                    console.log('Error for edit routines', error)
                  })
              }
  }
  commitUncompleteHabit(event: Event, routine){
    // this.hiddenRoutines[routine.path_id] = true;
    // this.commitService.closeModals()
    //    setTimeout(() => {
    //       this.homeUIService.openNextComponent(
    //         DailyStepsContentWebModalV2Component,
    //         {currentDay: routine.schedule_day, startFromScreen: 'daily-content-screen-routine'},
    //         'web-daily-steps-custom-modal')
    //     }, 1100);
              let unlockingHabitStepDetails = this.currentPath.findChapterStepByScreenContentId(this.dailyStepsArray, routine?.screenContentId)
      console.log("unlocking HabbitStepDetails", unlockingHabitStepDetails)
              let routineDay = unlockingHabitStepDetails?.stepPosition
              localStorage.removeItem(
                `Toggle:Day:${routineDay}:LevelNumber:${1}:true`
              )
              this.closeOpenItems();
              if (this.currentPath.id != routine.pathId) {
                localStorage.setItem('unlockingHabitStepDetails', JSON.stringify(unlockingHabitStepDetails))
                this.appState.set('isRoutineEdited', true)
                // this.spinnerService.on()
                this.homeUIService.changeSubPath(routine.pathId,routineDay,'daily-content-screen-routine-levels',false)
              } else {
                this.homeUIService.dismissAllModals().then(() => {
                  this.appState.set('levelUpdated', undefined)
                  this.appState.set('routine_schedule_day', routineDay)
                  this.appState.set('isRoutineEdited', true)
                  this.appState.set('LevelNumber', 1)
                  this.appState.set('indexOfLevel', 0);
                  this.appState.set('isFromEdit', true)
                  this.appState.set('hidePrevScreen', true);
                  this.appState.set("allowScreenCount", undefined)
                  this.commitService.dismissAllModals().then(() => {
                    this.appState.set("reviewingStepIndex",unlockingHabitStepDetails?.stepIndex);
                    if (this.isMobile) {
                      setTimeout(() => {
                        this.route.navigate(['/content', routineDay], { queryParams: { startFromScreen: 'daily-content-screen-routine-levels',currentOpenedChapter: unlockingHabitStepDetails?.chapterIndex, currentOpenedStep: unlockingHabitStepDetails?.stepIndex } })
                      }, 550);
                    } else {
                      this.commitService.closeModals()
                      setTimeout(() => {
                        this.homeUIService.openNextComponent(DailyStepsContentWebModalV2Component, { currentDay: routineDay, startFromScreen: 'daily-content-screen-routine-levels',currentOpenedChapter:unlockingHabitStepDetails?.chapterIndex}, 'web-daily-steps-custom-modal')
                      }, 1100);
                    }
                  });
                })
              }
      
  }

  async editHabitDetails(completed: boolean, routine,habitLevel) {
    const alert = await this.alertController.create({
      header: this.i18n.t('Are you sure?'),
      subHeader: completed ? this.i18n.t('Do you want to commit to this habit?') : this.i18n.t('Do you want to stop building this habit?'),
      buttons: [
        {
          text: this.i18n.t("No"),
          cssClass: 'custom-alert-textcase',
          handler: () => {
            if (completed) {
              this.editRoutineStatus()
            }
            else {
              this.editRoutineStatus()
            }
          },
          role: 'cancel',
        },
        {
          text: this.i18n.t("Yes"),
          cssClass: 'custom-alert',
          handler: () => {
            if (completed) {
               let unlockingHabitStepDetails = this.currentPath.findChapterStepByScreenContentId(this.dailyStepsArray, routine?.screenContentId)
      console.log("unlocking HabbitStepDetails", unlockingHabitStepDetails)
              let routineDay = unlockingHabitStepDetails?.stepPosition
              console.log('routineDay', routineDay);
              localStorage.removeItem(
                `Toggle:Day:${routineDay}:LevelNumber:${1}:true`
              )
              this.closeOpenItems();
              if (this.currentPath.id != routine.pathId) {
                this.appState.set('isRoutineEdited', true)
                // this.spinnerService.on()
                this.homeUIService.changeSubPath(routine.pathId,routineDay,'daily-content-screen-routine-levels',false)
              } else {
                this.homeUIService.dismissAllModals().then(() => {
                  this.appState.set('levelUpdated', undefined)
                  this.appState.set('routine_schedule_day', routineDay)
                  this.appState.set('isRoutineEdited', true)
                  this.appState.set('LevelNumber', 1)
                  this.appState.set('isFromEdit', true)
                  this.appState.set('hidePrevScreen', true);
                  this.appState.set("allowScreenCount", undefined)
                  this.commitService.dismissAllModals().then(() => {
                  this.appState.set("reviewingStepIndex", unlockingHabitStepDetails?.stepIndex);
                  let chapterPosition= unlockingHabitStepDetails?.chapterIndex
                    if (this.isMobile) {
                      setTimeout(() => {
                        this.route.navigate(['/content', routineDay], { queryParams: { startFromScreen: 'daily-content-screen-routine-levels',currentOpenedChapter: chapterPosition,currentOpenedStep: unlockingHabitStepDetails?.stepIndex} })
                      }, 550);
                    } else {
                      this.commitService.closeModals()
                      setTimeout(() => {
                        this.homeUIService.openNextComponent(DailyStepsContentWebModalV2Component, { currentDay: routineDay, startFromScreen: 'daily-content-screen-routine-levels',currentOpenedChapter:chapterPosition }, 'web-daily-steps-custom-modal')
                      }, 1100);
                    }
                  });
                })
              }
            }
            else {
              const requestData = {
                // 'user_id': routine.user_id,
                // 'path_id': routine.path_id,
                // 'is_reset': true,
                habit_id: habitLevel?.id,
                habit_group_id: routine?.habitGroupId
              }
              if (!requestData.habit_id || !requestData.habit_group_id) {
                return true;
              } else {
                this.routineService.editRoutine(requestData).subscribe(
                  (response) => {
                    console.log('status', response);
                    this.cdRef.detectChanges();
                    this.editRoutineStatus()
                  },
                  (error) => {
                    console.log('Error for edit routines', error)
                  })
              }
            }
          },
        },
      ]
    });
    await alert.present();
  }
  @HostListener('document:click', ['$event'])
  onClick(e) {
    const target = e.target as HTMLElement;
    // console.log("target in community", target, e.target.target, e.target.tagName.toLowerCase());
    const parent = target.closest('.web-todo-name');
    if (parent && this.cordovaService.onCordova && this.platform.is('ios')) {
      const href = target.getAttribute('href');
      if (href && e.target.tagName.toLowerCase() == 'a' && e.target.target == '_blank') {
        // Handle the link (open in new tab or custom logic)
        // window.open(href, '_blank');
         e.stopPropagation()
         e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target?.href);
      }
    
    }
    //      // Click was on the child link, prevent parent's click event
    //       if (this.cordovaService.onCordova && this.platform.is('ios')) {
    //         if (e.target.tagName.toLowerCase() == 'a' && e.target.target == '_blank') {
    //           console.log("called");
    //           e.stopPropagation()
    //           e.preventDefault()
    //         }
    //         else {
    //           this.cordovaService.openLinkInBrowser(e.target?.href);
    //         }
    //       }
    //     }
  }
}